import { updateFriendInCache } from "@/entities/friend"
import { showNotification } from "@/entities/notification"
import { registerNotification } from "@/shared/api/websocket"
import { trackVoiceNotification } from "../model/voice-notifications"

registerNotification("voice_message", {
	handle: ({ notification_id, data }, ctx) => {
		showNotification({
			type: "silent",
			placement: null,
			origin: "server",
			notificationId: notification_id,
			name: "voice_message",
		})
		trackVoiceNotification(data.friend_id, notification_id)
		if (!data.is_friend) return

		updateFriendInCache(
			ctx.queryClient,
			ctx.userId,
			data.friend_id,
			(friend) => ({
				...friend,
				unread_board: true,
			}),
		)
	},
	route: ({ data }) => {
		if (!data.is_friend) return { to: "/home" }
		return {
			to: "/board/friend/$friendId",
			params: { friendId: data.friend_id },
		}
	},
	routePopup: null,
})
